"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentUsage = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/link/link");
require("@/components/common/text/text");
require("@/components/domains/chart/chart-column");
/**
 * 컴포넌트별 사용량을 막대로 보이고, 고른 막대의 사용처를 아래에 편다.
 * 차트는 고른 값만 알리고, 사용처를 어떻게 보일지는 이 컴포넌트가 정한다.
 */
let ComponentUsage = class ComponentUsage extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.items = [];
        this.selected = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-chart-column
        selectable
        .items=${this.shares}
        .selected=${this.selected}
        @change=${this.handleSelectionChange}
      ></mm-chart-column>
      ${this.renderUsage()}
    `;
    }
    renderUsage() {
        const item = this.items.find(({ label }) => label === this.selected);
        if (!item)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text size="12" color="light">${item.pageCount}개 페이지에서 씁니다.</mm-text>
      ${this.renderPages(item)}
    `;
    }
    renderPages({ pages }) {
        if (!pages)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <div class="pages">
        ${pages.map(({ href, label }) => (0, lit_1.html) `
            <mm-link href=${href}>${label}</mm-link>
          `)}
      </div>
    `;
    }
    handleSelectionChange(event) {
        this.selected = event.detail.value;
    }
    /** 막대 높이는 가장 큰 값을 100으로 잡는다. */
    get shares() {
        const max = Math.max(...this.items.map(({ count }) => count));
        return this.items.map(({ label, count }) => ({
            label,
            share: Math.round((count / max) * 100),
            value: String(count),
        }));
    }
};
ComponentUsage.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-4);
    }

    .pages {
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-1) var(--space-4);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], ComponentUsage.prototype, "items", void 0);
__decorate([
    (0, decorators_js_1.state)()
], ComponentUsage.prototype, "selected", void 0);
ComponentUsage = __decorate([
    (0, decorators_js_1.customElement)('mm-component-usage')
], ComponentUsage);
exports.ComponentUsage = ComponentUsage;
//# sourceMappingURL=data:application/json;base64,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